import $ from 'jquery';
import Cookies from 'js-cookie';
import Carousel from 'bootstrap/js/src/carousel';
import {getDevType} from '@utils/commonUtils';
import {getUpRefUid} from '../../helpers/upRefCookieHelpers';
import abTestService from '../../services/abTestService';
import {initCountDown} from '../../helpers/promotionHelpers';
import RecentlyViewedItems from '../../components/RecentlyViewedItems';
import HeaderSearch from '../../components/HeaderSearch';
import Modals from '../../components/modals';

const SCP_ANNOUNCEMENT_DISMISS_COOKIE = 'scpAnnouncementDismissed',
      SCP_ANNOUNCEMENT_DISMISS_COOKIE_VALUE = '1',
      SCP_ANNOUNCEMENT_DISMISS_COOKIE_OPTIONS = {
	      'expires': 365,
	      'path'   : '/'
      };

export default class HomepageController {
	constructor({shouldInitializeCarousel} = {}) {
		this.shouldInitializeCarousel = shouldInitializeCarousel || (() => true);
		this.init();
	}

	init() {
		this.ticketInformationBanner();
		this.initSeatchampAnnouncementDismissal();
		new RecentlyViewedItems();
		initCountDown();

		if (!$('.homepageArrangementsListContainer').length) {
			const devType = getDevType();

			if (devType === 'tablet' || devType === 'desktop') {
				this.initCarousels();
			}
		}

		requestAnimationFrame(() => {
			new HeaderSearch();
			this.initEvents();
			new Modals();
			abTestService.sendEventWhenAssignmentsReady(
				['increase_user_trust_no', 'increase_user_trust_yes'],
				'homepageOpen'
			).catch(console.error);
		});
	}

	initCarousels() {
		const carousels = document.querySelectorAll('.carousel');

		carousels.forEach((carousel) => {
			if (!this.shouldInitializeCarousel(carousel)) {
				return;
			}

			new Carousel(carousel, {
				'interval': false
			});
		});
	}

	ticketInformationBanner() {
		const ticketInformationBanner      = $('.ticketInformationBanner'),
			  hideOfficialTicketOnHomePage = Cookies.get('hideTicketInformationBannerOnHomePage') || false;

		if (!hideOfficialTicketOnHomePage) {
			ticketInformationBanner.show();
		}

		ticketInformationBanner.on('click', '.close', () => {
			$('.ticketInformationBanner, .ticketInformationBannerOpenedBackground').remove();
			Cookies.set(
				'hideTicketInformationBannerOnHomePage',
				false,
				{
					'expires': 180
				}
			);
			$('body').removeClass('ticketInformationBannerOpened');
		});
	}

	initSeatchampAnnouncementDismissal() {
		const $wrapper = $('.seatchampAnnouncement-wrapper');

		if (!$wrapper.length) {
			return;
		}

		if (Cookies.get(SCP_ANNOUNCEMENT_DISMISS_COOKIE)) {
			$wrapper.remove();

			return;
		}

		$wrapper.one('click', '[data-seatchamp-announcement-close]', () => {
			Cookies.set(
				SCP_ANNOUNCEMENT_DISMISS_COOKIE,
				SCP_ANNOUNCEMENT_DISMISS_COOKIE_VALUE,
				SCP_ANNOUNCEMENT_DISMISS_COOKIE_OPTIONS
			);
			$wrapper.remove();
		});
	}

	initPreviousSearchFloatingPanel() {
		const $previousSearchBlock  = $('.prev-search-block'),
			  $floatingPanel        = $('.floatingPanel');

		if (!$previousSearchBlock.length) {
			return;
		}

		const MOBILE_MAX_WIDTH      = 575,
			  mobileMediaQuery      = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`),
			  $floatingSearchBlock  = $previousSearchBlock
				.clone()
				.addClass('d-none');

		$floatingPanel.prepend($floatingSearchBlock);

		const updateSearchBlockVisibility = (isMobileView) => {
			$previousSearchBlock.toggleClass('d-none', isMobileView);
			$floatingSearchBlock.toggleClass('d-none', !isMobileView);
		};

		updateSearchBlockVisibility(mobileMediaQuery.matches);

		mobileMediaQuery.addEventListener('change', ({matches}) => {
			updateSearchBlockVisibility(matches);
		});
	}

	initEvents() {
		this.initPreviousSearchFloatingPanel();

		$('.giftcard .centeredCtaButton').on('click', () => {
			dataLayer.push({
				'event'        : 'Book Gift Card CTA',
				'eventCategory': 'User-Action',
				'eventAction'  : 'Event_Book_Gift_Card_CTA',
				'eventLabel'   : 'Gift-Card-Funnel',
				'uid'          : getUpRefUid()
			});
		});

		$('.offers').find('.price.has-tip.tip-img, .topOffersHalfPayOption .has-tip').on('click', false);

		$('.giftcard .giftCardCta').one('mousedown', () => {
			abTestService.sendEventWhenAssignmentsReady(
				['moveHomepageReviewsUp_no', 'moveHomepageReviewsUp_yes'],
				'linkClicked'
			).catch(console.error);
		});
	}

}